import api from '../../utils/apiFetch';

const path = 'tickets';

export default {
  setTicketConfig: (payload) => api.post(`${path}`, payload),
  getTicketConfig: () => api.get(`${path}/config`),
  getTicketVenues: (params) =>
    api.get(`${path}/venues?${api.serialize(params)}`),
  getTicketTypes: (params) => api.get(`${path}/types?${api.serialize(params)}`),
  getTicketEvents: (params) =>
    api.get(`${path}/events?${api.serialize(params)}`),
  getEventInsights: (params) =>
    api.get(`${path}/event-insights?${api.serialize(params)}`),
  getTickets: (params) => api.get(`${path}/tickets?${api.serialize(params)}`),
  getOrders: (params) => api.get(`${path}/orders?${api.serialize(params)}`),
  getOrderItems: (params) => api.get(`${path}/order-items/${params}`),
  getTicketPricing: (params) =>
    api.get(`${path}/pricing?${api.serialize(params)}`),
  updateTicketPricingOrder: (payload) =>
    api.put(`${path}/pricing/order`, payload),
  updateStatusTicketConfig: (id, payload) =>
    api.post(`${path}/${id}/update-status`, payload),
  setDefaultTicketConfig: (id) => api.post(`${path}/${id}/set-default`),
  addVenue: (payload) => api.post(`${path}/venues`, payload),
  postTicketType: (payload) => api.post(`${path}/types`, payload),
  postTicketEvent: (payload) => api.post(`${path}/events`, payload),
  duplicateTicketEvent: (payload) =>
    api.post(`${path}/events/duplicate`, payload),
  previewRepeatTicketEvents: (payload) =>
    api.post(`${path}/events/repeat/preview`, payload),
  repeatTicketEvents: (payload) =>
    api.post(`${path}/events/repeat`, payload, { includeStatus: true }),
  postTicketPricing: (payload) => api.post(`${path}/pricing`, payload),
  getEventsDiscountsList: (payload) =>
    api.get(`${path}/events-discount/${payload}`),
  getEventMembershipPlanConfigList: (payload) =>
    api.get(
      `${path}/membership-plan-config/${payload?.id}?${api.serialize(payload)}`
    ),
  setEventsDiscounts: (payload) => api.post(`${path}/event-discount`, payload),
  editEventsDiscounts: (payload) => api.put(`${path}/event-discount`, payload),
  deleteEventsDiscounts: (id) => api.delete(`${path}/event-discount/${id}`),
  createEventMembershipPlanConfigList: (payload) =>
    api.post(`${path}/membership-plan-config`, payload),
  editEventMembershipPlanConfigList: (payload) =>
    api.put(`${path}/membership-plan-config`, payload),
  deleteEventMembershipPlanConfigList: (payload) =>
    api.delete(`${path}/membership-plan-config/${payload?.id}`, payload),
  editTicket: (id, payload) => api.put(`${path}/edit-ticket`, payload),
  deleteTicketEvent: (id) => api.delete(`${path}/events/${id}`),
  resendEmail: (payload) => api.get(`${path}/resend-email/${payload}`),
  getItemsByTicketing: () => api.get(`${path}/list-publish-event `),
  bulkTicketStatus: (payload) => api.post(`${path}/bulk-edit-status`, payload),
  bulkTicketAction: (payload) => api.post(`${path}/bulk-actions`, payload),
  bulkEventAction: (payload) => api.post(`${path}/events/bulk-action`, payload),
  sendCustomEmailApi: (payload) =>
    api.post(`${path}/send-custom-email`, payload),
  getSchemaApi: () => api.get(`${path}/seatmap-schema-relationships`),
  deleteTicketType: (id) => api.delete(`${path}/pricing/${id}`),
  deleteTicketPricingOfferCoupon: (id) =>
    api.delete(`${path}/pricing/${id}/offer-coupon`),
  issueTicketsApi: (payload) => api.post(`${path}/issue-tickets`, payload),
  calculateTicketCostApi: (payload) => api.post(`${path}/calculate`, payload),
  sellerCheckoutApi: (payload) => api.post(`${path}/seller-checkout`, payload),
  getEventTicketsApi: (params) =>
    api.get(`${path}/event-tickets?${api.serialize(params)}`),
  getEventCheckInLogs: (eventId, params) =>
    api.get(`${path}/events/${eventId}/check-in-logs?${api.serialize(params)}`),
  getReportEventTicketApi: (params) =>
    api.get(`stats/event-stats?${api.serialize(params)}`),
  getTicketPricingViewApi: (params) =>
    api.get(`stats/ticket-stats?${api.serialize(params)}`),
  refundTicketApi: (payload) =>
    api.put(`${path}/refund-ticket/${payload.id}`, { seatId: payload.seatId }),
};
